<template>
  <div class="wrap m-a ov-h influencer" id="wrap">
    <div class="kol-banner influencer-banner banner">
      <div class="w-1200 m-a">
        <div class="banner-content">
          <h1>Global Witness</h1>
          <p>Share your FJD experience!</p>
          <a class="join-btn" href="/kol">Join Us</a>
        </div>
      </div>
    </div>
    <div class="video-container m-a">
      <!-- <Row>
        <Col>
          <Card v-for="item in list" :key="item.index">
            <p slot="title">{{ item.title }}</p>
            <p>{{ item.content }}</p>
          </Card>
        </Col>
      </Row> -->
      <ul id="video-item">
        <li v-for="(item, index) in videoList" :key="index" @click="playVideo(item)">
          <div class="video-cover p-r">
            <div class="video-icon"></div>
            <img v-lazy="item.videoImage" width="100%" height="100%" alt="" /><span>{{ item.videoTime }}</span>
          </div>
          <div class="video-info">
            <h3>
              {{ item.videoTitle }}
            </h3>
            <div class="head-icon-auther-date">
              <em class="head-icon"><img width="100%" height="100%" v-lazy="item.userIcon" /></em>
              <div class="auther-date">
                <b>{{ item.userName }}</b>
                <span>{{ item.createTime | formatDate }}</span>
              </div>
            </div>
          </div>
        </li>
      </ul>
      <div class="page" v-if="totalCount > 10">
        <Page :total="totalCount" prev-text="PREV" next-text="NEXT" :page-size="6" />
      </div>
    </div>
    <Modal
      v-model="modal10"
      footer-hide
      :scrollable="false"
      width="60"
      :lock-scroll="false"
      class-name="vertical-center-modal"
    >
      <div slot="close">
        <svg-icon icon-class="video-close-white" class-name="close"></svg-icon>
      </div>

      <video
        v-if="isCloud"
        class="lazy-video"
        width="100%"
        height="100%"
        style="object-fit: none"
        x5-playsinline
        x5-video-player-type="h5"
        x-webkit-airplay="allow"
        playsinline
        webkit-playsinline
        muted
        loop
        autoplay
        controls
        :src="videoUrl"
      ></video>
      <!-- <div v-html="videoUrl"></div> -->
      <iframe
        v-else
        width="100%"
        height="100%"
        :src="videoUrl"
        frameborder="0"
        allow="autoplay"
        allowfullscreen=""
      ></iframe>
    </Modal>
  </div>
</template>

<script>
  export default {
    async asyncData(ctx) {
      try {
        const { data, totalCount } = await ctx.$api.homeApi.getInfluencerVideo({ pageNum: 1, pageSize: 6 })
        console.log('[ data ] >', data)
        return {
          videoList: data,
          totalCount
        }
      } catch (error) {
        return {
          videoList: [],
          totalCount: 0
        }
      }
    },
    data() {
      return {
        totalCount: 10,
        list: [
          {
            title: 'asdada',
            content: 'fffffff'
          },
          {
            title: 'wqeqeq',
            content: '331232'
          },
          {
            title: 'qweqeqe',
            content: '5768578'
          },
          {
            title: 'qweqeqe',
            content: '5768578'
          },
          {
            title: 'qweqeqe',
            content: '5768578'
          }
        ],
        videoList: [],
        modal10: false,
        videoUrl: '',
        isCloud: true
      }
    },
    created() {},
    mounted() {
      // this.getvideoList()
    },
    methods: {
      playVideo({ videoUrl, youtubeUrl }) {
        this.modal10 = true
        this.videoUrl = videoUrl || youtubeUrl
        if (youtubeUrl) {
          this.isCloud = false
          this.videoUrl = youtubeUrl
            .split(' ')
            .filter((item) => item.startsWith('src'))[0]
            .split('=')[1]
            .replace(/"/g, '')

          // console.log('[ this.videoUrl ] >', this.videoUrl)
        }
      }
      // async getvideoList() {
      //   const { data } = await this.$api.homeApi.getvideoList({ pageNum: 1, pageSize: 6 })
      //   console.log(data)
      // }
    }
  }
</script>

<style scoped lang="scss">
  :deep(.ivu-row) {
    flex-direction: row;
  }
  :deep(.ivu-card-bordered) {
    margin: 20px 10px 20px 0;
    min-width: 4.36rem;
  }
  :deep(.ivu-col) {
    display: flex;
    flex-flow: inherit;
  }
  @media screen and (min-width: 769px) {
    .w1000px {
      width: 1000px;
    }
    .influencer-banner {
      margin-top: 0.76rem;
      height: 3.6rem;
      background: url('@/assets/images/influencer/banner.jpg') no-repeat center;
      background-size: cover;
      overflow: hidden;
    }
    .influencer-banner h1 {
      font-size: 0.48rem;
      line-height: 1.5;
      margin: 0.99rem auto 0.08rem;
      color: #fff;
    }
    .influencer-banner h1 i {
      display: block;
    }
    .influencer-banner .banner-content {
      margin-left: 0;
      text-align: center;
    }
    .kol-banner p {
      color: #fff;
      font-size: 0.24rem;
    }
    .influencer-banner .join-btn {
      display: block;
      width: 1.06rem;
      font-size: 0.16rem;
      margin: 0.24rem auto 0;
      text-align: center;
      text-indent: 0;
      height: 0.4rem;
      line-height: 0.4rem;
      color: #333;
      background: rgba(255, 255, 255, 0.65);
      border-radius: 0;
      border: 1px solid transparent;
      box-sizing: border-box;
    }
    .video-container {
      padding: 1rem 2.75rem;
      overflow: hidden;
    }
    #video-item {
      // padding: 0.2rem 0.35rem 0;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
    }
    #video-item li {
      overflow: hidden;
      margin-bottom: 0.4rem;
      cursor: pointer;
    }
    #video-item li:nth-of-type(2) {
      margin: 0 0.16rem;
    }
    #video-item li:nth-of-type(5) {
      margin: 0 0.16rem;
    }
    #video-item li:hover img {
      transform: scale(1.02);
    }
    #video-item li img {
      overflow: hidden;
    }
    #video-item li:hover .video-cover .video-icon {
      width: 32px;
      height: 32px;
      background-repeat: no-repeat;
      background-size: cover;
      background: url("data:image/svg+xml,%3Csvg width='32' height='32' viewBox='0 0 32 32' xmlns='http://www.w3.org/2000/svg'%3E%3Cg stroke='%23FFF' stroke-width='1.5' fill='none' fill-rule='evenodd' stroke-linejoin='round'%3E%3Cpath d='M16 31c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15C7.716 1 1 7.716 1 16c0 8.284 6.716 15 15 15z' fill-opacity='.399' fill='%23FFF'/%3E%3Cpath d='M13 16v-5.196l4.5 2.598L22 16l-4.5 2.598-4.5 2.598z'/%3E%3C/g%3E%3C/svg%3E");
    }
    // 分页器
    .page {
      display: flex;
      justify-content: center;
      align-content: center;
    }
    :deep(.ivu-page-item) {
      &:hover {
        background: #eceaea;
      }
      border: 1px solid #262626;
      a {
        color: #262626;
      }
    }
    :deep(.ivu-page-item-active) {
      background: #262626;
      a {
        color: #fff;
      }
    }
    //  a:hover, .ivu-page-next a:hover
    :deep(.ivu-page-prev a) {
      font-weight: 500;
      // color: #262626;
      &:hover {
        font-weight: 600;
        // color: #262626;
      }
    }
    :deep(.ivu-page-next a) {
      font-weight: 500;
      // color: #262626;
      &:hover {
        font-weight: 600;
        // color: #262626;
      }
    }
    :deep(.ivu-page-item-jump-next:hover i:first-child, .ivu-page-item-jump-prev:hover i:first-child) {
      color: #262626;
    }
    :deep(.ivu-page-item-jump-prev:hover i:first-child) {
      color: #262626;
    }
    // :deep(.ivu-page-prev) {
    //   position: relative;
    //   &::before {
    //     position: absolute;
    //     content: ' ';
    //     left: -0.3rem;
    //     top: 0.05rem;
    //     width: 0.2rem;
    //     height: 0.2rem;
    //     width: 0.2rem;
    //     height: 0.2rem;
    //     background-image: url("data:image/svg+xml,%3Csvg width='20' height='20' viewBox='0 0 20 20' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='%23262626' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round' d='M12.25 4l-6 6 6 6' fill='none' fill-rule='evenodd'/%3E%3C/svg%3E");
    //   }
    // }
    // :deep(.ivu-page-disabled) {
    //   background-image: url("data:image/svg+xml,%3Csvg width='20' height='20' viewBox='0 0 20 20' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='%238C8C8C' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round' d='M12.25 4l-6 6 6 6' fill='none' fill-rule='evenodd'/%3E%3C/svg%3E");
    // }
    .video-cover,
    .video-cover a {
      display: block;
      width: 4.4rem;
      height: 2.48rem;
      background-color: #eee;
      overflow: hidden;
    }
    .video-cover a {
      overflow: hidden;
    }
    .video-cover img {
      /* transition: all 0.5s; */
      transition: all 0.3s linear;
    }
    .video-cover a:hover img {
      transform: scale(1.05);
    }
    .video-cover span {
      display: block;
      position: absolute;
      right: 0.24rem;
      bottom: 0.16rem;
      width: 0.45rem;
      height: 0.2rem;
      text-align: center;
      line-height: 18px;
      /* background-color: #000; */
      font-size: 0.16rem;
      color: #fff;
    }
    .video-cover .video-icon {
      border-radius: 50%;
      width: 32px;
      height: 32px;
      position: absolute;
      top: 0;
      left: 0;
      right: 0px;
      bottom: 0;
      margin: auto;
      background: url("data:image/svg+xml,%3Csvg width='32' height='32' viewBox='0 0 32 32' xmlns='http://www.w3.org/2000/svg'%3E%3Cg stroke='%23FFF' stroke-width='1.5' fill='none' fill-rule='evenodd' stroke-linejoin='round'%3E%3Cpath d='M16 31c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15C7.716 1 1 7.716 1 16c0 8.284 6.716 15 15 15z'/%3E%3Cpath d='M13 16v-5.196l4.5 2.598L22 16l-4.5 2.598-4.5 2.598z'/%3E%3C/g%3E%3C/svg%3E");
      background-size: cover;
      cursor: pointer;
      z-index: 2;
    }
    .video-info h3 {
      // font-size: 0.28rem;
      // line-height: 1.5;
      // font-weight: 500;
      // height: 0.6rem;
      // color: #262626;
      // margin: 0.24rem 0.24rem 0.32rem 0.24rem;
      // display: block;
      // -webkit-line-clamp: 2;
      // -webkit-box-orient: vertical;
      // text-overflow: ellipsis;
      font-size: 0.2rem;
      line-height: 1.5;
      font-weight: 500;
      color: #262626;
      margin: 0.24rem 0.24rem 0.32rem 0.24rem;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .video-info {
      display: flex;
      flex-direction: column;
      padding-bottom: 0.32rem;
      justify-content: space-between;
      box-sizing: border-box;
      /* margin-top: -2px; */
      width: 4.4rem;
      height: 2.04rem;
      overflow: hidden;
      /* border-radius: 4px; */
      border: 1px solid #ebebeb;
      border-top: none;
      box-sizing: border-box;
    }
    .video-info h3 {
      font-size: 0.2rem;
      line-height: 1.5;
      font-weight: 500;
      color: #262626;
      margin: 0.24rem 0.24rem 0.32rem 0.24rem;
      display: block;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .video-info h3 a {
      color: #333;
    }
    .head-icon {
      width: 44px;
      height: 44px;
      border-radius: 50%;
      margin-right: 10px;
      overflow: hidden;
    }
    .head-icon-auther-date {
      padding: 0 0.24rem;
      display: flex;
      /* align-items: center; */
    }
    // .head-icon-auther-date img {
    //   width: 0.64rem;
    //   height: 0.64rem;
    //   border-radius: 50%;
    //   margin-right: 0.16rem;
    // }
    .head-icon-auther-date div {
      flex: 3;
    }
    .auther-date span,
    .auther-date b {
      display: block;
      font-size: 0.16rem;
      margin-bottom: 0.08rem;
      font-weight: 400;
    }
    .auther-date span {
      color: #8c8c8c;
    }
  }

  @media screen and (max-width: 1900px) {
    .video-container {
      padding: 1rem 2.74rem;
    }
  }

  @media screen and (max-width: 1650px) {
    .video-container {
      padding: 1rem 2.73rem;
    }
  }
  @media screen and (max-width: 1480px) {
    .video-container {
      padding: 1rem 2.72rem;
    }
  }
  @media screen and (max-width: 1366px) {
    .video-container {
      padding: 1rem 2.71rem;
    }
  }
  @media screen and (max-width: 1260px) {
    .video-container {
      padding: 1rem 2.7rem;
    }
  }
  @media screen and (max-width: 1200px) {
    .video-container {
      padding: 1rem 2.68rem;
    }
  }

  // 弹窗
  :deep(.vertical-center-modal) {
    display: flex;
    align-items: center;
    justify-content: center;

    .ivu-modal {
      top: 0;
    }
  }
  :deep(.ivu-modal-body) {
    padding: 0;
    height: 70vh;
  }
  :deep(.ivu-modal-content) {
    background: #000;
    box-sizing: border-box;
    // overflow: hidden;
  }
  :deep(.ivu-modal-close) {
    top: -30px;
    right: -30px;
  }
  .close {
    width: 30px;
    height: 30px;
  }
</style>
